import { Component, OnInit, inject } from "@angular/core";
import { Router, RouterLink } from "@angular/router";

@Component({
  selector: "app-not-found-page",
  standalone: true,
  imports: [RouterLink],
  template: `
    <div class="flex min-h-screen items-center justify-center bg-muted">
      <div class="text-center">
        <h1 class="mb-4 text-4xl font-bold">404</h1>
        <p class="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a routerLink="/" class="text-primary underline hover:text-primary/90"
          >Return to Home</a
        >
      </div>
    </div>
  `,
})
export class NotFoundPageComponent implements OnInit {
  private readonly router = inject(Router);

  ngOnInit() {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      this.router.url,
    );
  }
}
